// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeSunbit_titleIcon__3CVxM","inputPhoneContainer":"ViewChargeSunbit_inputPhoneContainer__1npSG"};